







































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { currencyMap, changedInvestColumns } from '@/utils/finance';
import { fundListCommon } from '@/api/finance.js';
import { roundSimpleList } from '@/api/common';
import roundSelect from '@/components/base/roundSelect.vue';

@Component({
  components: { roundSelect }
})
class EventEditTable extends Vue {
  currencyMap = currencyMap;
  // fundList: any[] = [];
  columnsCanEdit: any[] = ['eventClassOfShareId','eventNature','eventFundId','eventCurrency','eventAmount','eventShareNum','eventTotalShareNum'];
  columns: any[] = changedInvestColumns;
  editingKey: string = '';
  roundMap: any = {};
  companySelected: any = {};
  filterFundList = [];

  @Prop()
  dealDataTableWithSum;

  @Prop({
    type: Array,
    default: () => []
  })
  fundList;

  @Watch('fundList')
  fundListChange(val) {
    this.filterFundList = val;
  }

  async created() {
    this.getRoundList();
  }

  formatNum(value) {
    return `${value}`.replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
  }

  parseNum(value) {
    return value.replace(/\$\s?|(,*)/g, '');
  }

  filterFund(key) {
    //@ts-ignore Type 'any[]' is not assignable to type 'never[]'
    this.filterFundList = this.fundList.filter(_ => {
      return new RegExp(key.trim(), 'i').test(_.fundName);
    });
  }

  // 表格数据编辑变化
  handleChange(value, id, column) {
    this.$emit('handleChange', value, id, column);
  }

  // 点表格行的编辑
  tableRawEdit(id) {
    this.$emit('tableRawEdit', id);
  }

  tableRowSave(id) {
    this.$emit('tableRowSave', id);
  }

  tableRawCancel(id) {
    this.$emit('tableRawCancel', id);
  }

  async getRoundList() {
    try {
      let res = await roundSimpleList();
      if (res.code === 200) {
        let tmp = res.data || [];
        tmp.forEach(_ => {
          this.roundMap[_.id] = _.name;
        });
      }
    } catch (error) {
    }
  }
}

export default EventEditTable;
